import React from 'react';
import "./../../../../styles/FactCheckCard.css";

const FactCheckCardSkeleton = ({ count = 1, showContainer = true }) => {
  const SingleSkeletonCard = () => (
    <div className="skeleton-fact-card">
      <div className="skeleton-fact-card-image-container skeleton-shimmer">
        <div className="skeleton-fact-card-badge skeleton-shimmer"></div>
      </div>
      
      <div className="skeleton-fact-card-content">
        <div className="skeleton-fact-card-title skeleton-shimmer"></div>
        <div className="skeleton-fact-card-title-second skeleton-shimmer"></div>
        
        <div className="skeleton-fact-card-meta">
          <div className="skeleton-meta-date skeleton-shimmer"></div>
          <div className="skeleton-meta-separator"></div>
          <div className="skeleton-meta-author skeleton-shimmer"></div>
        </div>
        
        <div className="skeleton-fact-card-description">
          <div className="skeleton-description-line skeleton-shimmer"></div>
          <div className="skeleton-description-line skeleton-shimmer"></div>
          <div className="skeleton-description-line skeleton-shimmer"></div>
        </div>
        
        <div className="skeleton-fact-card-button skeleton-shimmer"></div>
      </div>
    </div>
  );

  // Single card without container
  if (count === 1 && !showContainer) {
    return <SingleSkeletonCard />;
  }

  // Multiple cards with container (same flex behavior as original)
  return (
    <div className="skeleton-cards-container">
      {Array.from({ length: count }, (_, index) => (
        <SingleSkeletonCard key={index} />
      ))}
    </div>
  );
};

export default FactCheckCardSkeleton;